<div class="grid -mr-3 -ml-3 pn-container flex-column flex-wrap align-items-center justify-content-center">

    <div class="col-12 lg:w-9">
        <div class="surface-card p-5 text-center" [ngStyle]="{'display' : showReceipt ? 'none' : 'flex' }">
            <div class="surface-border p-1">
                <span class="text-400 font-medium text-lg lg:text-lg font-bold">Receipt loading...</span>
            </div>
        </div>

        <div class="surface-section pn-order-1" [ngStyle]="{'display' : showReceipt ? 'block' : 'none' }">
            <div align="center" class="surface-border pb-5">
                <partner-image></partner-image><br/>
                <span class="font-medium text-xl text-900">{{partnerName}}</span>
            </div>
            <div *ngIf="receitpModel">
                <div *ngIf="!receitpModel.review">
                    <div class="font-bold text-4xl my-2">Your payment is successful</div>
                    <div style="height:3px;background:linear-gradient(90deg, #2196F3 0%, rgba(33, 150, 243, 0) 50%);"></div>
                </div>
                <div *ngIf="receitpModel.review">
                    <div class="font-bold text-4xl my-2">Your payment is under review</div>
                    <div style="height:3px;background:linear-gradient(90deg, #fde047 0%, rgba(33, 150, 243, 0) 50%);"></div>
                </div>
                <div class="flex flex-column sm:flex-row sm:align-items-center sm:justify-content-between py-5">
                    <div class="mb-3 sm:mb-0">
                        <span class="font-medium text-xl text-900 mr-2">Order number:</span>
                        <span class="font-medium text-xl text-blue-700">{{orderId}}</span><br/>
                        <span *ngIf="receitpModel" class="font-medium text-sm text-600">{{receitpModel.orderDate | date:'MM/dd/yyyy hh:mm a'}}</span>
                    </div>
                    <div>
                        <button pButton label="Print" class="noPrint" icon="pi pi-print" (click)="printReceipt()"></button>
                    </div>
                </div>
            </div>
            <div *ngIf="!receitpModel">
                <div>
                    Your order has been processed successfully. However, we were unable to display the receipt at this time.
                </div>
                <div>
                    A copy of your receipt has been sent to your registered email address.
                </div>
                <div>
                    If you do not receive the email within a few minutes, please contact our Customer Service team for further assistance.
                </div>
            </div>
            <div class="border-round surface-border border-1" *ngIf="receitpModel">
                <ul class="list-none p-0 m-0">
                    <li class="p-3 border-bottom-1 surface-border flex align-items-start sm:align-items-center"
                        *ngFor="let item of receitpModel.paymentItems">
                        <div class="flex flex-column">
                            <span class="text-900 font-medium text-xl mb-2">{{item.itemName}}</span>
                            <span class="text-600 mb-3">{{item.skuLabel}} : {{item.skuValue}}</span>
                            <span *ngFor="let att of item.attributes" class="text-600 mb-3">
                                {{att.receiptDisplay?(att.attribute +':'+att.value):'' }} </span>
                        </div>
                        <span class="text-600 font-medium text-lg ml-auto">{{item.amount | currency:'USD':'symbol':'.2-2'}}</span>
                    </li>
                    
                </ul>
            </div>
            <div class="flex flex-wrap mt-5 pb-3" *ngIf="receitpModel">
                <div class="w-full lg:w-6 pl-3 pn-order-2">
                    <span class="font-medium text-900">Payment</span>
                    <div class="flex align-items-center mt-3">
                        <div class="flex flex-column">
                            <span class="text-900 mb-1">{{paymentSummary}}</span>
                            <span class="text-900 font-medium"></span>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-6 pl-3 lg:pl-0 lg:pr-3 flex align-items-end mt-5 lg:mt-0 pn-order-3">
                    <ul class="list-none p-0 m-0 w-full">
                        <li class="mb-3"><span class="font-medium text-900">Summary</span></li>
                        <li class="flex justify-content-between mb-3">
                            <span class="text-900">Subtotal</span>
                            <span class="text-900">{{subTotalAmount() |
                                currency:'USD':'symbol':'.2-2'}}</span>
                        </li>
                        <li class="flex justify-content-between mb-3" *ngIf="receitpModel.feeItems && receitpModel.feeItems.length > 0">
                            <span class="text-900">{{receitpModel.feeItems[0].skuLabel}}</span>
                            <span class="text-900">{{receitpModel.feeItems[0].amount| currency:'USD':'symbol':'.2-2'}}</span>
                        </li>
                        <li class="flex justify-content-between border-top-1 surface-border py-3">
                            <span class="text-900">Total</span>
                            <span class="text-900">{{receitpModel.paymentAmount | currency:'USD':'symbol':'.2-2' }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="text-sm border-round surface-border border-1 p-2" *ngIf="receitpModel">
                {{disclaimer}}
            </div>
        </div>
    </div>
    <div class="col-12 lg:w-9 noPrint flex justify-content-center" *ngIf="paymentInfo?.returnURL">
        <p-button  rel="noopener noreferrer" class=" font-bold text-white text-center noPrint" severity="secondary"  (onClick)="returnURL()">
            Return to {{paymentInfo?.partnerName}}
        </p-button>
    </div>
</div>